import styled from 'styled-components';

export const Wrap = styled.div`
    + div {
        padding-top: 16px;
    }

    z-index: 3;
    position: relative;
    display: flex;
    padding: 8px;
    width: 100%;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: ${({ theme }) => theme.colors.Color1};
    * {
        color: #fff;
        fill: #fff;
    }
    a {
        text-decoration: underline;
        &:hover {
            color: #fff;
        }
    }
`;

export const CloseButton = styled.div`
    margin: 0 12px;
    height: 16px;
    cursor: pointer;
`;
